import { AuthService } from "./../../shared/models/auth.service";
import { Injectable, Inject } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { WeGoConfig, IAPIResponse, DataListModel } from "../../shared/config";
import { AdminInvitationProfileModel } from "./admin-invitation.model";

@Injectable()
export class AdminInvitationService {
  constructor(private authService: AuthService, private http: Http) {}

  public CheckActivationCodeIsValid(
    activationCode: string
  ): Observable<IAPIResponse> {
    let getPersonUrl =
      WeGoConfig.API_GET_CHECK_ADMIN_VALID_ACTIVATION_CODE +
      "?activationCode=" +
      activationCode;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getPersonUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public CheckPersonExistByActivationCode(
    activationCode: string
  ): Observable<IAPIResponse> {
    let getPersonUrl =
      WeGoConfig.API_GET_CHECK_ADMIN_USER_EXIST_BY_ACTIVATION_CODE +
      "?activationCode=" +
      activationCode;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getPersonUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public CheckPersonRoleExistByActivationCode(
    activationCode: string
  ): Observable<IAPIResponse> {
    let getPersonUrl =
      WeGoConfig.API_GET_CHECK_ADMIN_USER_ROLE_EXIST_BY_ACTIVATION_CODE +
      "?activationCode=" +
      activationCode;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getPersonUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  

  public InvitationRejected(rejectionCode: string): Observable<IAPIResponse> {
    let getPersonUrl =
      WeGoConfig.API_GET_REJECT_ADMIN_INVITATION_BY_REJECTION_CODE +
      "?rejectionCode=" +
      rejectionCode;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getPersonUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public InvitationAccepted(activationCode: string): Observable<IAPIResponse> {
    let getPersonUrl =
      WeGoConfig.API_GET_ACCEPT_ADMIN_INVITATION_BY_APPROVAL_CODE +
      "?activationCode=" +
      activationCode;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getPersonUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public AddPersonProfile(
    personModel: AdminInvitationProfileModel
  ): Observable<IAPIResponse> {
    let body = personModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_ADMIN_ADD_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-invitation/models/admin-invitation.service.ts